// extracted by mini-css-extract-plugin
export var avatarContainer = "_8w-0";
export var avatarTypingWave = "_8w-i";
export var gray = "_8w-f";
export var green = "_8w-c";
export var icon = "_8w-9";
export var image = "_8w-1";
export var lg = "_8w-6";
export var md = "_8w-5";
export var presenceDot = "_8w-b";
export var red = "_8w-d";
export var sm = "_8w-4";
export var status = "_8w-a";
export var typingDot = "_8w-h";
export var typingPill = "_8w-g";
export var xl = "_8w-7";
export var xs = "_8w-3";
export var xxl = "_8w-8";
export var xxs = "_8w-2";
export var yellow = "_8w-e";